import Vue from 'vue';
import VueI18n from 'vue-i18n';

import es from './es.json'
import en from './en.json'

Vue.use(VueI18n)

let locale = '';

if(sessionStorage.getItem('lang')) {
    locale = sessionStorage.getItem('lang');
} else {
    locale = 'es';
    sessionStorage.setItem('lang', 'es');
}






let messages = {
    es,
    en
}



const i18n = new VueI18n({
    locale,
    messages
})

export default i18n;


